import React from "react";
import { createMarkup, isFieldError } from "../../helpers";

const InputDate = ({
  type = "date",
  label,
  note = "",
  reqd,
  name,
  value,
  update,
  errors,
  autocomplete = name,
  placeholder = "",
}) => {
  return (
    <div className={isFieldError(errors, name) ? "has-error" : ""}>
      <label htmlFor={name} className="control-label">
        <span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
        {reqd && <span className="reqd">*</span>}
      </label>

      <input
        type={type}
        name={name}
        id={name}
        defaultValue={value || ""}
        onChange={(e) => update(name, e.target.value)}
        autoComplete={autocomplete}
        placeholder={placeholder}
        className={
          isFieldError(errors, name)
            ? "form-control error-border"
            : "form-control"
        }
      />

      <span className={note ? "note" : "hidden"}>{note}</span>
    </div>
  );
};

export default InputDate;
